<template>
  <div class="invite-wrapper">
    <template v-if="detail.banner_img || detail.activity_id">
      <div class="banner" v-if="detail.banner_img">
        <img :src="detail.banner_img" alt="邀请活动" />
      </div>
      <div class="info-bar">
        <div class="info-content">
          <div class="progress-stats">
            <div class="stat-left">
              <span class="stat-label">当前爱心值</span>
              <div class="stat-value-row">
                <span class="stat-value primary">{{ detail.user_available_uv || 0 }}</span>
                <span class="stat-arrow">▲</span>
              </div>
            </div>
            <div class="stat-right">
              <span class="stat-label accent">已邀请</span>
              <div class="stat-value-row">
                <span class="stat-value accent">{{ detail.invited_count || 0 }}</span>
                <span class="stat-unit accent">人</span>
              </div>
            </div>
          </div>
          <div class="progress-bar">
            <div class="progress-track">
              <div class="progress-fill" :style="{ width: progressPercent + '%' }"></div>
            </div>
          </div>
          <p class="progress-tip">{{ progressTip }}</p>
          <p class="invite-link">
            <span class="label">邀请链接</span>
            <span class="link" @click="copyInviteUrl" title="点击复制">{{ inviteUrl }}</span>
          </p>
        </div>
        <div class="rules-box">
          <div class="rules-title">规则说明</div>
          <div class="rules-text">{{ detail.rules_text }}</div>
        </div>
      </div>
      <div class="goods-section" v-if="goodsList.length">
        <div class="section-title">活动奖品</div>
        <div class="goods-list">
          <div class="goods-item" v-for="item in goodsList" :key="item.activity_goods_id">
            <div class="goods-card">
              <div class="goods-img">
                <img :src="item.image_url" :alt="item.goods_name" />
              </div>
              <div class="goods-info">
                <div class="goods-name">{{ item.goods_name }}</div>
                <!-- <div class="goods-brief">{{ item.brief }}</div> -->
                <div class="goods-meta">
                  <span class="invite-point">爱心值 <em>{{ item.invite_num }}</em></span>
                  <span class="stock">库存 {{ item.stock }}</span>
                </div>
                <div class="goods-status">
                  <span v-if="!item.stock" class="status sold-out">已抢光</span>
                  <span v-else-if="!item.is_unlocked" class="status locked">爱心值不足</span>
                  <span v-else class="status unlocked" @click="openRedeemDialog(item)">可兑换</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="goods-empty" v-else-if="!goodsLoading">
        <div class="section-title">活动奖品</div>
        <p>暂无奖品</p>
      </div>
      <div class="invite-log-section">
        <div class="section-title">邀请记录</div>
        <el-table
          v-if="inviteLogList.length"
          :data="inviteLogList"
          style="width: 100%"
        >
          <el-table-column label="头像" width="100" align="center">
            <template slot-scope="scope">
              <img
                class="log-avatar"
                :src="scope.row.invitee_avatar || defaultAvatar"
                alt=""
              />
            </template>
          </el-table-column>
          <el-table-column label="昵称" align="center" min-width="120">
            <template slot-scope="scope">
              {{ scope.row.invitee_name || scope.row.invitee_nickname || '未设置昵称' }}
            </template>
          </el-table-column>
          <!-- <el-table-column label="手机号" align="center" min-width="140">
            <template slot-scope="scope">
              {{ scope.row.invitee_mobile || '-' }}
            </template>
          </el-table-column> -->
          <el-table-column label="邀请时间" align="center" min-width="180">
            <template slot-scope="scope">
              {{ scope.row.ctime || '-' }}
            </template>
          </el-table-column>
        </el-table>
        <div class="log-empty" v-else-if="!inviteLogLoading">暂无邀请记录</div>
        <Pagination
          v-if="inviteLogTotalPage > 1"
          :totalPage="inviteLogTotalPage"
          :limit="inviteLogLimit"
          @changePage="handleInviteLogPage"
        />
      </div>
      <div class="redeem-order-section">
        <div class="section-title">我的兑换订单</div>
        <el-table
          v-if="orderList.length"
          :data="orderList"
          style="width: 100%"
        >
          <el-table-column label="奖品" min-width="220" align="left">
            <template slot-scope="scope">
              <div class="order-goods">
                <img class="order-goods-img" :src="scope.row.image_url" alt="" />
                <span class="order-goods-name">{{ scope.row.goods_name || '-' }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="订单号" align="center" min-width="160">
            <template slot-scope="scope">
              <router-link
                v-if="scope.row.order_id"
                class="order-link"
                :to="{ name: 'orderDetail', params: { order_id: scope.row.order_id } }"
              >{{ scope.row.order_id }}</router-link>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="消耗爱心值" align="center" width="120">
            <template slot-scope="scope">
              {{ scope.row.consume_uv }}
            </template>
          </el-table-column>
          <el-table-column label="发货状态" align="center" width="100">
            <template slot-scope="scope">
              {{ scope.row.ship_status_text || '-' }}
            </template>
          </el-table-column>
          <!-- <el-table-column label="收货人" align="center" min-width="160">
            <template slot-scope="scope">
              <div>{{ scope.row.ship_name || '-' }}</div>
              <div class="order-sub">{{ scope.row.ship_mobile || '' }}</div>
            </template>
          </el-table-column> -->
          <el-table-column label="兑换时间" align="center" min-width="160">
            <template slot-scope="scope">
              {{ scope.row.redeem_time || '-' }}
            </template>
          </el-table-column>
        </el-table>
        <div class="log-empty" v-else-if="!orderLoading">暂无兑换订单</div>
        <Pagination
          v-if="orderTotalPage > 1"
          :totalPage="orderTotalPage"
          :limit="orderLimit"
          @changePage="handleOrderPage"
        />
      </div>
    </template>
    <div class="empty" v-else-if="!loading">暂无活动</div>

    <el-dialog
      title="选择收货地址"
      :visible.sync="addressDialogVisible"
      width="600px"
      custom-class="invite-address-dialog"
      @close="handleAddressDialogClose"
    >
      <div class="invite-address-body">
        <div class="address-dialog-toolbar">
          <span class="toolbar-tip">请选择用于兑换的收货地址</span>
          <el-button class="add-address-btn" size="small" icon="el-icon-plus" @click="addAddressFunc">添加收货地址</el-button>
        </div>
        <div class="address-dialog" v-if="addressList.length">
          <div
            class="address-item"
            v-for="item in addressList"
            :key="item.id"
            :class="{ active: selectedAddress && selectedAddress.id === item.id }"
            @click="selectAddress(item)"
          >
            <div class="address-content">
              <div class="address-head">
                <span class="name">{{ item.name }}</span>
                <span class="tel">{{ item.mobile }}</span>
                <span class="default-tag" v-if="item.is_def == 1">默认</span>
              </div>
              <div class="address-detail">{{ item.area_name }} {{ item.address }}</div>
            </div>
            <span class="select-dot"></span>
          </div>
        </div>
        <div class="address-empty" v-else>
          <i class="el-icon-location-outline"></i>
          <p>暂无收货地址</p>
          <span>请点击右上角添加收货地址</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="foot-btn save" :class="{ disabled: !selectedAddress || redeeming }" @click="submitRedeem">
          {{ redeeming ? '兑换中...' : '确认兑换' }}
        </div>
        <div class="foot-btn cancel" @click="addressDialogVisible = false">取消</div>
      </div>
    </el-dialog>

    <SelectAddress
      :dialogAdressVisible="dialogAddressShow"
      @hideDialog="hideAddAddressDialog"
      :data="modifyData"
    />
  </div>
</template>

<script>
import { showLoading, hideLoading } from '../../utils/loading'
import SelectAddress from '@/components/address/index'
import Pagination from '@/components/common/Pagination.vue'
import { apiBaseUrl } from '@/config/env'

export default {
  name: 'Invite',
  components: { SelectAddress, Pagination },
  data() {
    return {
      loading: true,
      goodsLoading: true,
      inviteLogLoading: true,
      orderLoading: true,
      detail: {},
      goodsList: [],
      inviteLogList: [],
      inviteLogPage: 1,
      inviteLogLimit: 5,
      inviteLogTotalPage: 0,
      orderList: [],
      orderPage: 1,
      orderLimit: 5,
      orderTotalPage: 0,
      addressDialogVisible: false,
      dialogAddressShow: false,
      modifyData: null,
      currentGoods: null,
      selectedAddress: null,
      redeeming: false,
      userId: '',
      invite: ''
    }
  },
  computed: {
    inviteUrl() {
      return `${apiBaseUrl}web/?invitecode=${this.invite}`
    },
    addressList() {
      return this.$store.state.addressList
    },
    defaultAvatar() {
      return (this.$store.state.config && this.$store.state.config.shop_default_image) || ''
    },
    maxInvite() {
      return Number(this.detail.max_invite_per_user) || 15
    },
    validUv() {
      return Number(this.detail.invited_count) || 0
    },
    progressPercent() {
      if (!this.maxInvite) return 0
      return Math.min(100, Math.round((this.validUv / this.maxInvite) * 100))
    },
    progressTip() {
      const remain = Math.max(0, this.maxInvite - this.validUv)
      if (remain <= 0) {
        return `已达到邀请上限 ${this.maxInvite} 人`
      }
      return `再邀请${remain}位好友即可达到${this.maxInvite * 10}个爱心值`
    }
  },
  mounted() {
    this.initUserId()
    this.getInviteActivityDetail()
  },
  methods: {
    initUserId() {
        this.$api.shareCode({}).then(res => {
        if(res.status) {
          // localStorage.setItem('invite', res.data)

          this.invite = res.data
        }
      })
    //   const userInfo = this.$store.state.userInfo || this.$storage.get('userInfo') || {}
    //   if (userInfo.id) {
    //     this.userId = userInfo.id
    //     return
    //   }
    //   this.$api.userInfo({}).then(res => {
    //     if (res.status && res.data) {
    //       this.userId = res.data.id
    //       this.$storage.set('userInfo', res.data)
    //       this.$store.commit('getUserInfo', res.data)
    //     }
    //   })
    },
    getInviteActivityDetail() {
      showLoading()
      this.$api.getInviteActivityDetail({}).then(res => {
        if (res.status && res.data) {
          this.detail = res.data
          this.getInviteActivityGoodsList()
          this.getInviteLogList()
          this.getOrderList()
        } else {
          this.goodsLoading = false
          this.inviteLogLoading = false
          this.orderLoading = false
        }
      }).finally(() => {
        this.loading = false
        hideLoading()
      })
    },
    getInviteActivityGoodsList() {
      this.goodsLoading = true
      const params = {}
      if (this.detail.activity_id) {
        params.activity_id = this.detail.activity_id
      }
      this.$api.getInviteActivityGoodsList(params).then(res => {
        if (res.status && res.data) {
          this.goodsList = Array.isArray(res.data) ? res.data : (res.data.list || [])
        }
      }).finally(() => {
        this.goodsLoading = false
      })
    },
    getInviteLogList() {
      this.inviteLogLoading = true
      const params = {
        page: this.inviteLogPage,
        limit: this.inviteLogLimit
      }
      this.$api.getInviteActivityInviteLog(params).then(res => {
        if (res.status && res.data) {
          this.inviteLogList = res.data.list || []
          const total = Number(res.data.total || 0)
          this.inviteLogTotalPage = total ? Math.ceil(total / this.inviteLogLimit) : 0
        }
      }).finally(() => {
        this.inviteLogLoading = false
      })
    },
    handleInviteLogPage(val) {
      this.inviteLogPage = val
      this.getInviteLogList()
    },
    getOrderList() {
      this.orderLoading = true
      const params = {
        page: this.orderPage,
        limit: this.orderLimit
      }
      this.$api.getInviteActivityOrderList(params).then(res => {
        if (res.status && res.data) {
          this.orderList = res.data.list || []
          const total = Number(res.data.total || 0)
          this.orderTotalPage = total ? Math.ceil(total / this.orderLimit) : 0
        }
      }).finally(() => {
        this.orderLoading = false
      })
    },
    handleOrderPage(val) {
      this.orderPage = val
      this.getOrderList()
    },
    copyInviteUrl() {
      if (!this.inviteUrl) return
      const text = this.inviteUrl
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success('复制成功')
        }).catch(() => {
          this.fallbackCopy(text)
        })
      } else {
        this.fallbackCopy(text)
      }
    },
    fallbackCopy(text) {
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('复制成功')
    },
    openRedeemDialog(item) {
      this.currentGoods = item
      this.selectedAddress = null
      this.addressDialogVisible = true
      this.loadAddressList()
    },
    loadAddressList(options = {}) {
      const { selectNewest = false, keepSelected = false } = options
      const prevCount = this.addressList.length
      const prevSelectedId = keepSelected && this.selectedAddress ? this.selectedAddress.id : null

      return this.$api.userShip({}).then(res => {
        if (!res.status) return
        const list = res.data || []
        this.$store.commit('getUserShipList', list)

        if (selectNewest && list.length > prevCount) {
          this.selectedAddress = list.reduce((latest, item) => (
            Number(item.id) > Number(latest.id) ? item : latest
          ))
          return
        }

        if (prevSelectedId) {
          this.selectedAddress = list.find(item => item.id === prevSelectedId) || null
        }

        if (!this.selectedAddress && list.length) {
          const defaultAddress = list.find(item => item.is_def == 1)
          this.selectedAddress = defaultAddress || list[0]
        }
      })
    },
    addAddressFunc() {
      this.modifyData = {}
      this.dialogAddressShow = true
    },
    hideAddAddressDialog() {
      this.dialogAddressShow = false
      this.loadAddressList({ selectNewest: true, keepSelected: true })
    },
    handleAddressDialogClose() {
      this.currentGoods = null
      this.selectedAddress = null
      this.redeeming = false
    },
    selectAddress(address) {
      this.selectedAddress = address
    },
    submitRedeem() {
      if (this.redeeming || !this.currentGoods || !this.selectedAddress) return
      this.redeeming = true
      this.$api.redeemInviteActivityPrize({
        activity_goods_id: this.currentGoods.activity_goods_id,
        ship_id: this.selectedAddress.id
      }).then(res => {
        if (res.status) {
          this.$message.success(res.msg || '兑换成功')
          this.addressDialogVisible = false
          this.refreshActivityData()
          this.orderPage = 1
          this.getOrderList()
        } else {
          this.$message.error(res.msg || '兑换失败')
        }
      }).finally(() => {
        this.redeeming = false
      })
    },
    refreshActivityData() {
      this.$api.getInviteActivityDetail({}).then(res => {
        if (res.status && res.data) {
          this.detail = res.data
        }
      })
      this.getInviteActivityGoodsList()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variable.scss";

.invite-wrapper {
  color: #333;

  .banner {
    overflow: hidden;
    border-radius: 4px;

    img {
      display: block;
      width: 100%;
      // height: 200px;
      object-fit: cover;
    }
  }

  .info-bar {
    display: flex;
    align-items: stretch;
    margin-top: 24px;
    gap: 20px;

    .info-content {
      flex: 1;
      padding: 24px 28px;
      background: #fff;
      border-radius: 16px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
      box-sizing: border-box;

      .progress-stats {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
      }

      .stat-left,
      .stat-right {
        display: flex;
        flex-direction: column;
      }

      .stat-right {
        align-items: flex-end;
        text-align: right;
      }

      .stat-label {
        margin-bottom: 8px;
        font-size: 14px;
        font-weight: 600;
        color: #333;

        &.accent {
          font-weight: 500;
          color: #fa8c16;
        }
      }

      .stat-value-row {
        display: flex;
        align-items: baseline;
        gap: 4px;
      }

      .stat-value {
        font-size: 36px;
        font-weight: 700;
        line-height: 1;
        letter-spacing: 0.5px;

        &.primary {
          color: $theme-color;
        }

        &.accent {
          font-size: 30px;
          color: #fa8c16;
        }
      }

      .stat-arrow {
        font-size: 12px;
        color: $theme-color;
        transform: translateY(-4px);
      }

      .stat-unit {
        font-size: 14px;
        font-weight: 600;

        &.accent {
          color: #fa8c16;
        }
      }

      .progress-bar {
        margin-top: 20px;
      }

      .progress-track {
        height: 10px;
        overflow: hidden;
        background: #f0f0f0;
        border-radius: 10px;
      }

      .progress-fill {
        height: 100%;
        min-width: 0;
        border-radius: 10px;
        background: linear-gradient(90deg, lighten($theme-color, 8%) 0%, $theme-color 100%);
        transition: width 0.3s ease;
      }

      .progress-tip {
        margin: 12px 0 0;
        font-size: 13px;
        line-height: 1.5;
        color: #999;
        text-align: center;
      }

      .invite-link {
        margin: 20px 0 0;
        padding-top: 18px;
        border-top: 1px solid #f0f0f0;

        .label {
          display: block;
          margin-bottom: 8px;
          font-size: 13px;
          color: #999;
        }

        .link {
          display: block;
          padding: 10px 12px;
          font-size: 13px;
          line-height: 1.6;
          color: #666;
          word-break: break-all;
          background: #fafafa;
          border: 1px solid #eee;
          border-radius: 8px;
          cursor: pointer;
          transition: border-color 0.2s, color 0.2s;

          &:hover {
            color: $theme-color;
            border-color: rgba($theme-color, 0.4);
          }
        }
      }
    }

    .rules-box {
      flex-shrink: 0;
      width: 380px;
      max-height: none;
      padding: 24px 28px;
      overflow-y: auto;
      background: #fff;
      border-radius: 16px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
      box-sizing: border-box;

      .rules-title {
        margin-bottom: 16px;
        font-size: 16px;
        font-weight: 700;
        line-height: 1.5;
        text-align: center;
        color: #333;
      }

      .rules-text {
        font-size: 13px;
        line-height: 1.8;
        color: #666;
        text-align: left;
        white-space: pre-wrap;
        word-break: break-word;
      }
    }
  }

  .section-title {
    position: relative;
    height: 44px;
    line-height: 44px;
    padding: 0 0 0 14px;
    margin-bottom: 16px;
    font-size: 18px;
    font-weight: 600;
    color: #333;
    border-bottom: 1px solid #eee;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      width: 4px;
      height: 18px;
      margin-top: -9px;
      background: $theme-color;
      border-radius: 2px;
    }
  }

  .goods-section {
    margin-top: 28px;
  }

  .goods-list {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -8px;

    .goods-item {
      width: 25%;
      padding: 0 8px 16px;
      box-sizing: border-box;
      background: transparent;
      border: none;
      border-radius: 0;
      overflow: visible;
      text-align: center;
      transition: none;

      &:hover {
        box-shadow: none;

        .goods-card {
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }

        .goods-img img {
          transform: scale(1.03);
        }
      }

      .goods-card {
        overflow: hidden;
        background: #fff;
        border: 1px solid #f0f0f0;
        transition: box-shadow 0.3s ease;
      }

      .goods-img {
        width: 100%;
        aspect-ratio: 1 / 1;
        position: relative;
        overflow: hidden;
        background: #f5f5f5;

        img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }
      }

      .goods-info {
        padding: 10px 0 0;
        background: #fff;

        .goods-name,
        .goods-brief,
        .goods-meta {
          padding: 0 10px;
        }

        .goods-name {
          height: 40px;
          line-height: 20px;
          margin-bottom: 6px;
          font-size: 14px;
          font-weight: 500;
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          line-clamp: 2;
        }

        .goods-brief {
          margin-top: 4px;
          margin-bottom: 6px;
          height: 36px;
          font-size: 12px;
          color: #999;
          line-height: 18px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          line-clamp: 2;
        }

        .goods-meta {
          margin: 0 0 10px;
          font-size: 12px;
          line-height: 1.5;

          .invite-point {
            display: block;
            color: #666;

            em {
              font-style: normal;
              font-size: 18px;
              font-weight: 600;
              color: $theme-color;
            }
          }

          .stock {
            display: block;
            margin-top: 2px;
            color: #999;
          }
        }

        .goods-status {
          margin-top: 0;

          .status {
            display: block;
            width: 100%;
            height: 36px;
            line-height: 36px;
            padding: 0;
            font-size: 13px;
            border-radius: 0;
            box-sizing: border-box;
            text-align: center;
          }

          .redeemed,
          .sold-out,
          .locked {
            color: #999;
            background: #f5f5f5;
          }

          .unlocked {
            color: #fff;
            font-weight: 500;
            background: $theme-color;
            cursor: pointer;

            &:hover {
              opacity: 0.9;
            }
          }
        }
      }
    }
  }

  .goods-empty {
    margin-top: 28px;

    p {
      padding: 48px 0;
      text-align: center;
      color: #999;
      font-size: 14px;
      background: #fafafa;
    }
  }

  .invite-log-section,
  .redeem-order-section {
    margin-top: 36px;

    .log-avatar {
      width: 40px;
      height: 40px;
      object-fit: cover;
      vertical-align: middle;
      background: #f5f5f5;
    }

    .log-empty {
      padding: 48px 0;
      text-align: center;
      color: #999;
      font-size: 14px;
      background: #fafafa;
    }

    .order-goods {
      display: flex;
      align-items: center;

      .order-goods-img {
        flex-shrink: 0;
        width: 48px;
        height: 48px;
        margin-right: 10px;
        object-fit: cover;
        background: #f5f5f5;
      }

      .order-goods-name {
        font-size: 13px;
        color: #333;
        line-height: 1.4;
        text-align: left;
      }
    }

    .order-link {
      color: $theme-color;

      &:hover {
        text-decoration: underline;
      }
    }

    .order-sub {
      margin-top: 4px;
      font-size: 12px;
      color: #999;
    }
  }

  .empty {
    padding: 80px 0;
    text-align: center;
    color: #999;
    font-size: 14px;
    background: #fafafa;
    border-radius: 4px;
  }
}

.address-dialog-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px dashed #eee;

  .toolbar-tip {
    font-size: 13px;
    color: #999;
  }

  .add-address-btn {
    color: $theme-color;
    border-color: rgba($theme-color, 0.5);
    background: #fff;

    &:hover,
    &:focus {
      color: #fff;
      border-color: $theme-color;
      background: $theme-color;
    }
  }
}

.address-dialog {
  height: 280px;
  overflow-y: auto;
  padding-right: 4px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #e0e0e0;
  }

  .address-item {
    display: flex;
    align-items: center;
    padding: 16px;
    margin-bottom: 12px;
    border: 1px solid #e0e0e0;
    cursor: pointer;
    background: #fff;
    transition: border-color 0.2s, background 0.2s;

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      border-color: $theme-color;
    }

    &.active {
      border-color: $theme-color;
      background: rgba($theme-color, 0.04);

      .select-dot {
        border-color: $theme-color;
        background: $theme-color;

        &::after {
          opacity: 1;
        }
      }
    }

    .select-dot {
      position: relative;
      flex-shrink: 0;
      width: 18px;
      height: 18px;
      margin-left: 12px;
      border: 2px solid #dcdfe6;
      border-radius: 50%;
      box-sizing: border-box;
      transition: all 0.2s;

      &::after {
        content: '';
        position: absolute;
        top: 2px;
        left: 5px;
        width: 4px;
        height: 8px;
        border-right: 2px solid #fff;
        border-bottom: 2px solid #fff;
        opacity: 0;
        transform: rotate(45deg);
        transition: opacity 0.2s;
      }
    }

    .address-content {
      flex: 1;
      min-width: 0;
    }

    .address-head {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: 8px;
      font-size: 14px;
      color: #333;

      .name {
        font-size: 15px;
        font-weight: 600;
      }

      .tel {
        margin-left: 12px;
        color: #666;
      }

      .default-tag {
        margin-left: 12px;
        padding: 0 8px;
        font-size: 12px;
        line-height: 20px;
        color: $theme-color;
        background: rgba($theme-color, 0.08);
        border: 1px solid rgba($theme-color, 0.2);
      }
    }

    .address-detail {
      font-size: 13px;
      line-height: 1.7;
      color: #757575;
      word-break: break-all;
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: center;

  .foot-btn {
    width: 160px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    cursor: pointer;
    border-radius: 0;

    &.save {
      background: $theme-color;
      margin-right: 20px;

      &.disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }

      &:not(.disabled):hover {
        opacity: 0.9;
      }
    }

    &.cancel {
      background: #b0b0b0;
      transition: all 0.2s;

      &:hover {
        background: #757575;
      }
    }
  }
}

.address-empty {
  height: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 20px;
  text-align: center;
  color: #999;
  background: #fafafa;
  border: 1px dashed #e8e8e8;

  i {
    display: block;
    margin-bottom: 12px;
    font-size: 40px;
    color: #ddd;
  }

  p {
    margin: 0 0 6px;
    font-size: 15px;
    color: #666;
  }

  span {
    font-size: 13px;
    color: #999;
  }
}
</style>

<style lang="scss">
@import "@/assets/css/variable.scss";

.invite-address-dialog {
  border-radius: 0;
  overflow: hidden;

  .el-dialog__header {
    padding: 15px 20px;
    background: #ffc300 !important;
    border-bottom: none;

    .el-dialog__title {
      font-size: 16px;
      font-weight: 400;
      line-height: 1;
      color: #333;
    }

    .el-dialog__headerbtn {
      top: 15px;
      right: 18px;

      .el-dialog__close {
        font-size: 18px;
        color: #666;

        &:hover {
          color: #333;
        }
      }
    }
  }

  .el-dialog__body {
    padding: 0 !important;
  }

  .invite-address-body {
    padding: 16px 20px 20px;
  }

  .el-dialog__footer {
    padding: 20px 0;
    background: #f5f5f5;
    border-top: none;
  }
}
</style>
